import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';

export default class SetBonusTable extends Component {
    render() {
        const {bonuses, name} = this.props;

        if(!bonuses || bonuses.length === 0 ) {
            return null;
        }

        const bonusRows = bonuses.map(b =>
            <Table.Row key={b.RequiredPieces}>
                <Table.Cell>{b.RequiredPieces}</Table.Cell>
                <Table.Cell>{b.Description.English}</Table.Cell>
            </Table.Row>
        );

        const nameHeader = name ?
                            <Header as='h3' textAlign='center'>
                                <Header.Content>
                                    {name.English}
                                </Header.Content>
                            </Header> :
                            null;

        return (
            <div>
                {nameHeader}
                <Table compact celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Pieces</Table.HeaderCell>
                            <Table.HeaderCell>Bonus</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {bonusRows}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

SetBonusTable.propTypes = {
    bonuses: PropTypes.array.isRequired,
    name: PropTypes.object,
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/itemsets/SetBonusTable.jsx